import { cliengoQueries, Website } from '@cliengo/mfe-utils/mod';
import { useWebsiteId } from './useWebsiteId';

interface WebsiteWithLabs extends Omit<Website, 'labs'> {
  labs?: Record<string, boolean>;
}

export const useCurrentWebsite = () => {
  const websiteId = useWebsiteId();
  const { data: website, isLoading, error } = cliengoQueries.website(websiteId);

  return {
    website: website as WebsiteWithLabs,
    isLoading,
    error,
    isValid: !!website && !!websiteId,
  };
};